import { Util, devLog } from "utils";
import { HOST } from "consts/env";
import { FetchManager } from "services/FetchManager";
import { create } from "zustand";

export interface ChatbotStoreType {
  getChatbotResponse: (
    question: string,
    signal: AbortSignal,
    projectInfo?: {
      projectVersion: string;
      projectId: string;
    }
  ) => Promise<any>;
  getChartResponse: (
    question: string,
    libraryDetailId: string,
    signal: AbortSignal
  ) => Promise<any>;
}

const useChatbotAPIStore = create<ChatbotStoreType>((set) => ({
  async getChatbotResponse(
    question: string,
    signal: AbortSignal,
    projectInfo?: {
      projectVersion: string;
      projectId: string;
    }
  ) {
    const body: {
      questionMessage: string;
      projectVersion?: string;
      projectId?: string;
    } = {
      questionMessage: question,
    };

    if (projectInfo) {
      body.projectVersion = String(projectInfo.projectVersion);
      body.projectId = projectInfo.projectId;
    }

    try {
      const url = `${HOST}/chat`;
      const res = await FetchManager.post(url, body, signal);
      const data = await Util.fetchAndSetData(res);

      if (data) return data;
      else throw new Error(res instanceof Error ? res.name : undefined);
    } catch (e: any) {
      devLog("[getChatbotResponse] 오류 발생", e);
      return { isSuccess: false, error: e.message };
    }
  },
  async getChartResponse(
    question: string,
    libraryDetailId: string,
    signal: AbortSignal
  ) {
    try {
      const url = `${HOST}/chat/chart`;
      const res = await FetchManager.post(
        url,
        {
          questionMessage: question,
          libraryDetailId: libraryDetailId,
        },
        signal
      );

      const data = await Util.fetchAndSetData(res);

      if (data) return data;
      else throw new Error(res instanceof Error ? res.name : undefined);
    } catch (e: any) {
      devLog("[getChartResponse] 오류 발생", e);
      return { isSuccess: false, error: e.message };
    }
  },
}));

export default useChatbotAPIStore;
